import { DescriptionList as DescriptionListComponent } from "components/DescriptionList";

function DescriptionList({ module }) {
  return <DescriptionListComponent data={module.fields} />;
}

export { DescriptionList };
